export const CHAIN_TYPE = {
    EVM: 'EVM',
    BITCOIN: 'BITCOIN',
    TRON: 'TRON',
    ICP: 'ICP',
    SOLANA: 'SOLANA',
    NEAR: 'NEAR',
    CARDANO: 'CARDANO',
    AION: 'AION',
    ALGORAND: 'ALGORAND',
    APTOS: 'APTOS',
    ARDOR: 'ARDOR',
    ARK: 'ARK',
    ASTAR: 'ASTAR',
    COSMOS: 'COSMOS',
    BAND_PROTOCOL: 'BAND_PROTOCOL',
    BITCOIN_DIAMOND: 'BITCOIN_DIAMOND',
    BSV: 'BSV',
    BITCOIN_GOLD: 'BITCOIN_GOLD',
    CASPER: 'CASPER',
    DASH: 'DASH',
    DECRED: 'DECRED',
    DIGI_BYTE: 'DIGI_BYTE',
    DIVI: 'DIVI',
    DOGECOIN: 'DOGECOIN',
    POLKADOT: 'POLKADOT',
    MULTIVERS_X: 'MULTIVERS_X',
    FIO_PROTOCOL: 'FIO_PROTOCOL',
    FIRO: 'FIRO',
    FLOW: 'FLOW',
    HEDERA: 'HEDERA',
    HELIUM: 'HELIUM',
    ICON: 'ICON',
    IOST: 'IOST',
    IOTA: 'IOTA',
    KADENA: 'KADENA',
    KOMODO: 'KOMODO',
    KUSAMA: 'KUSAMA',
    LISK: 'LISK',
    LITECOIN: 'LITECOIN',
    TERRA: 'TERRA',
    TERRA_CLASSIC: 'TERRA_CLASSIC',
    MINA_PROTOCOL: 'MINA_PROTOCOL',
    NANO: 'NANO',
    NEO: 'NEO',
    OSMOSIS: 'OSMOSIS',
    PIVX: 'PIVX',
    POLYX: 'POLYX',
    QTUM: 'QTUM',
    THOR_CHAIN: 'THOR_CHAIN',
    RAVENCOIN: 'RAVENCOIN',
    SIA: 'SIA',
    SECRET: 'SECRET',
    STACKS: 'STACKS',
    STEEM: 'STEEM',
    STRATIS: 'STRATIS',
    SOLAR: 'SOLAR',
    TON: 'TON',
    VE_CHAIN: 'VE_CHAIN',
    WAVES: 'WAVES',
    WAX: 'WAX',
    DX_CHAIN: 'DX_CHAIN',
    E_CASH: 'E_CASH',
    NEM: 'NEM',
    STELLAR: 'STELLAR',
    MONERO: 'MONERO',
    RIPPLE: 'RIPPLE',
    TEZOS: 'TEZOS',
    VERGE: 'VERGE',
    SYMBOL: 'SYMBOL',
    ZCASH: 'ZCASH',
    HORIZEN: 'HORIZEN',
    ZILLIQA: 'ZILLIQA',
    KAVA_COSMOS: 'KAVA_COSMOS',
    XDC: 'XDC',
    ONTOLOGY: 'ONTOLOGY',
    EOS: 'EOS',
    FILECOIN: 'FILECOIN',
    SUI: 'SUI'
} as const;

export type ChainType = (typeof CHAIN_TYPE)[keyof typeof CHAIN_TYPE];
